var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPictogramBeaconControl40(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2422_9609)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 5.50269C28.2843 5.50269 35 12.2184 35 20.5027C35 28.787 28.2843 35.5027 20 35.5027C11.7157 35.5027 5 28.787 5 20.5027C5 12.2184 11.7157 5.50269 20 5.50269ZM31.5425 23.5025L28.0016 23.5027C24.6067 23.5027 21.8547 26.2542 21.8547 29.6547L21.8554 32.2823C26.5665 31.5462 30.3636 28.0515 31.5425 23.5025ZM17.615 32.1872L17.6154 29.6547C17.6154 26.257 14.8565 23.5027 11.4667 23.5027L8.45746 23.5025C9.59184 27.8798 13.1505 31.2808 17.615 32.1872ZM20 8.57961C14.619 8.57961 10.0706 12.1442 8.58726 17.0408H31.4127C29.9294 12.1442 25.381 8.57961 20 8.57961Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5311C21.5652 24.5311 22.834 23.2622 22.834 21.697C22.834 20.1319 21.5652 18.863 20 18.863C18.4348 18.863 17.166 20.1319 17.166 21.697C17.166 23.2622 18.4348 24.5311 20 24.5311Z",
    fill: "#FAEC20",
    stroke: "#1E1E1E",
    strokeWidth: 1.1
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2422_9609"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.502686)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictogramBeaconControl40);
export default __webpack_public_path__ + "static/media/pictogramBeaconControl40.e4331bca16a26b07af44c113cde608ed.svg";
export { ForwardRef as ReactComponent };